import { setUser, clearUser } from "@/store/slices/auth";
import { type AppDispatch } from "@/store";
import { type QueryClient } from "@/core";
import { type IUser } from "@/store/slices/auth";
import { logger } from "@/core";

/**
 * Shared auth utilities
 * These are the truly shared pieces - extracted once ,used everywhere
 */

/** Set authenticated user in Redux store */

export const setAuthUser = (dispatch: AppDispatch, user: IUser): void => {
  dispatch(setUser(user));
  logger.info("Auth user set", { user });
};

/** Clear all auth state */

export const clearAuthState = (
  dispatch: AppDispatch,
  queryClient: QueryClient,
): void => {
  dispatch(clearUser());
  queryClient.clear();
  logger.info("Auth state cleared");
};

/** Get Dashboard route based on user role */
export const getDashboardRoute = (user: IUser): string => {
  switch (user.role) {
    case "super_admin":
      return "/dashboard";
    case "teacher":
    case "user":
      return "/courses";
    default:
      return "/";
  }
};
